// imove-branch: 当前用户是否是主办方或组织成员

export default async function(ctx) {
  const status = ctx.getPipe();
  return status.is_host||status.is_host_org_member;
}